<template>
  <div>
    <v-layout
      v-for="(discountItem, index) in discounts"
      :key="`discount-line-${index}`"
      align-center
      class="my-1"
    >
      <v-flex>
        <div>
          <span>{{ discountItem.name }} </span>
        </div>
        <div class="my-1 grey--text">
          <div>
            <span>{{ $t('Discount type') }}: </span>
            <span class="text-capitalize">{{ discountItem.discount_type }} </span>
          </div>
          <div>
            <span>{{ $t('Rate type') }}: </span>
            <span class="text-capitalize">{{ discountItem.rate_type }}</span>
            <span
              v-if="discountItem.rate_type === 'percentage'"
            >
              ({{ discountItem.rate }}%)
            </span>
          </div>
        </div>
        <div
          v-if="discountItem.code"
          class="grey--text">
          <span>{{ $t('Code') }}: {{ discountItem.code }}</span>
        </div>
      </v-flex>
      <v-flex :class="$vuetify.rtl | rtlTextAlign">
        <span>-{{ discountItem.discount | money }}</span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'OrderDiscountBreakdown',

  props: {
    discounts: {
      type: Array,
      required: true
    }
  }
}
</script>
